import type { FormFooterProps } from '.';

export function FormFooter({ children, ...props }: FormFooterProps) {
  return (
    <div className="flex justify-end gap-4" {...props}>
      {children}
    </div>
  );
}
